import { useState } from "react";
import { useParams } from "react-router-dom";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import Search from "../Components/Search";
import Navigation from "../Components/navigation";
import HospitalPatientTable from "./hospital-patient-table";

const searchOptions = [
  { id: "name", name: "환자명" },
  { id: "phone", name: "휴대전화 번호" },
];

const sortOptions = [
  { id: "LATEST", name: "최신순" },
  { id: "OLDEST", name: "등록일시순" },
  { id: "NAME", name: "환자명" },
];

const HospitalDetailPatientPage = () => {
  const { id } = useParams();
  const [filter, setFilter] = useState({ orderBy: "LATEST" });
  const [keyword, setKeyword] = useState("");
  const [searchBy, setSearchBy] = useState("name");

  const handleSearch = (e) => {
    e.preventDefault();
    const { orderBy } = filter;
    setFilter({
      orderBy,
      [searchBy]: keyword,
    });
  };

  const onResetFilter = () => {
    setKeyword("");
    setFilter({
      orderBy: filter.orderBy || "LATEST",
    });
  };

  return (
    <div>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="patient" hospitalId={id} />
      <div className="flex mt-8 justify-between">
        <div className="gap-2 flex">
          <Dropdown
            width="w-[10rem]"
            placeholder="환자명"
            textColor="text-black"
            positionDropdown="top-10"
            options={searchOptions}
            onClickItem={(value) => setSearchBy(value)}
          />
          <Search
            placeholder="검색어 입력"
            keyword={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onSubmit={handleSearch}
            handleSearch={handleSearch}
            onResetFilter={onResetFilter}
          />
        </div>
        <div>
          <Dropdown
            textColor="text-black"
            positionDropdown="top-10 right-0"
            dropdownWidth="w-[8rem]"
            width="w-[8rem]"
            placeholder="최신순"
            options={sortOptions}
            onClickItem={(value) => setFilter({ ...filter, orderBy: value })}
          />
        </div>
      </div>
      <div className="mt-4">
        <HospitalPatientTable filter={filter} hospitalId={id} />
      </div>
    </div>
  );
};

export default HospitalDetailPatientPage;
